
import * as React from 'react'
import { Text, View, ScrollView, TouchableOpacity } from 'react-native'
import { CalendarList } from 'react-native-calendars'
import moment from 'moment'
import { Ionicons, Entypo } from '@expo/vector-icons'
import { useTheme } from '@react-navigation/native'
import { useSafeAreaInsets } from 'react-native-safe-area-context'
import MonthPicker from '../libs/MonthPicker/index'
import AsyncStorage from '@react-native-async-storage/async-storage'
import Recipe from '../components/Calendar/Recipe'
import DayComponent from '../components/Calendar/DayComponent'
// import MonthPicker from 'react-native-month-picker'
import CalendarCustom from './CalendarCustom'


export default function ModalCalendar({ navigation, route }) {
    const { colors } = useTheme()
    const insets = useSafeAreaInsets()
    let markedDates = {}
    const [indexFilter, setIndexFilter] = React.useState(route.params?.tripFilter)
    const [merchant, setMerchant] = React.useState()
    let day_string = route.params?.day_string ? moment(route.params?.day_string, 'DD/MM/YYYY').format('YYYY-MM-DD') : moment().format('YYYY-MM-DD')
    let month_string = route.params?.month_string
    const [selectedDate, changeDate] = React.useState(moment(month_string, 'MM/YYYY'))
    const [fullDate, setFullDate] = React.useState(moment(month_string, 'YYYY/MM/DD'))
    const [currentDate, setCurrentDate] = React.useState(day_string)
   
    const onSetCurrentDate = (date) => {
       
        setCurrentDate(date)
        // onChooseDay(date.dateString)
    }

    markedDates[day_string] = {
        customStyles: {
            container: {
                backgroundColor: colors.text,
                borderRadius: 20,
            },
            text: {
                color: 'white',
                fontFamily: 'Nunito_700Bold'
            },
        },
    }

    React.useEffect(() => {
        const restoreState = async () => {
            try {
                const tmp_ = await AsyncStorage.getItem('merchant')
                let item = null
                if (tmp_) item = JSON.parse(tmp_)

                setMerchant(item)
            } catch (error) {
                console.log(error)
            }
        }
        if (!merchant) {
            restoreState()
        }
    }, [])

    React.useEffect(() => {
        setCurrentDate(day_string)
    }, [day_string])


    const activeFilter = (idx) => {
        if (idx == indexFilter) {
            return {
                backgroundColor: merchant?.color,
                borderColor: merchant?.color,
            }
        } return {
            backgroundColor: '#fff',
            borderColor: colors.text_sub
        }
    }




    return (
        <View style={{ flex: 1, backgroundColor: '#fff' }}>
            <View style={{ paddingTop: insets.top ? insets.top : 0, flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                <TouchableOpacity onPress={() => navigation.goBack()}>
                    <Ionicons name="ios-close" size={32} color={colors.text} style={{ paddingHorizontal: 24, paddingVertical: 8 }} />
                </TouchableOpacity>
                <Text style={{ flex: 1, textAlign: 'center', color: colors.text, fontFamily: 'Nunito_700Bold', fontSize: 16 }}>
                    {month_string ? 'CHỌN THÁNG' : 'CHỌN NGÀY'}
                </Text>
                <TouchableOpacity>
                    <Ionicons name="ios-close" size={32} color={colors.text} style={{ paddingHorizontal: 24, paddingVertical: 8, opacity: 0 }} />
                </TouchableOpacity>
            </View>
            {
                month_string ? <View>
                    <MonthPicker
                        monthTextStyle={{ color: colors.text, fontFamily: 'Nunito_700Bold' }}
                        yearTextStyle={{ fontFamily: 'Nunito_700Bold', fontSize: 15, paddingVertical: 6 }}
                        containerStyle={{ alignItems: 'space-between' }}
                        monthFormat='MM'
                        selectedDate={selectedDate}
                        onMonthChange={(date) => {
                            
                            changeDate(moment(date.format('MM/YYYY'), 'MM/YYYY'))
                            setFullDate(date.format('YYYY/MM/DD'))
                            // navigation.navigate('Home', { screen: route.params.tab_screen, params: { day: date.format('MM/YYYY'), full_date: date.format('YYYY/MM/DD') } })
                        }}
                        onYearChange={newDate => console.log(newDate)}
                        maxDate={moment()}
                        minDate={moment().subtract(2, 'year')}
                        currentMonthTextStyle={{ color: '#0aa9c2' }}
                        nextIcon={<Entypo name="chevron-right" size={18} color="black" style={{ paddingVertical: 6, paddingHorizontal: 12 }} />}
                        prevIcon={<Entypo name="chevron-left" size={18} color="black" style={{ paddingVertical: 6, paddingHorizontal: 12 }} />}
                        seperatorHeight={1}
                        seperatorColor='lightgray'
                    />
                </View> : <ScrollView>
                    <CalendarCustom 
                     customReqire={false}
                     propDay={currentDate}
                     onChooseDay={(day) =>{onSetCurrentDate(day)}} 
                     />
                    {/* <CalendarList
                        pastScrollRange={5}
                        futureScrollRange={0}
                        scrollEnabled={true}
                        showScrollIndicator={true}
                        current={moment().format('YYYY-MM-DD')}
                        // onDayPress={(day) => {
                        //     navigation.navigate('Home', { screen: route.params.tab_screen, params: { day: day.dateString } })
                        // }}
                        theme={{
                            'stylesheet.calendar.header': {
                                dayHeader: {
                                    fontFamily: 'Nunito_700Bold',
                                    color: '#48BFE3'
                                }
                            },

                        }}
                        dayComponent={({ date }) => {
                            let lunarDay = Recipe.convertSolar2Lunar(date.day, date.month, date.year, 7.0)[0]
                            let lunarMonth = Recipe.convertSolar2Lunar(date.day, date.month, date.year, 7.0)[1]

                            return (
                                <DayComponent
                                    currentDate={currentDate}
                                    lunarDay={lunarDay}
                                    lunarMonth={lunarMonth}
                                    date={date}
                                    onChooseDate={(date) => onSetCurrentDate(date)}
                                />
                            );
                        }}
                        markingType={'custom'}
                        markedDates={markedDates}
                    /> */}

                </ScrollView>
            }
            <View style={{ paddingVertical: 16, paddingHorizontal: 16 }}>
                <Text style={{
                    fontSize: 18, fontFamily: 'Nunito_700Bold', fontWeight: '500'
                }}>Trạng thái chuyến</Text>
            </View>
            <View style={{ flexDirection: 'row', paddingHorizontal: 16 }}>
                <TouchableOpacity
                    onPress={() => setIndexFilter(3)}
                    style={[styles.itemFilter, activeFilter(3)]}>
                    <Text>Tất cả</Text>
                </TouchableOpacity>
                <TouchableOpacity
                    onPress={() => setIndexFilter(1)}
                    style={[styles.itemFilter, activeFilter(1)]}>
                    <Text>Chưa xuất bến</Text>
                </TouchableOpacity>
                <TouchableOpacity
                    onPress={() => setIndexFilter(2)}
                    style={[styles.itemFilter, activeFilter(2)]}>
                    <Text>Đã xuất bến</Text>
                </TouchableOpacity>
            </View>
            <TouchableOpacity
                activeOpacity={0.6}
                onPress={() => {
                    month_string ?
                        navigation.navigate('Home', { screen: route.params.tab_screen, params: { day: selectedDate.format('MM/YYYY'), full_date: fullDate, filter: indexFilter } }) :
                        navigation.navigate('Home', { screen: route.params.tab_screen, params: { day: currentDate, filter: indexFilter } })
                }}
                style={{
                    marginHorizontal: 16,
                    marginBottom: 32,
                    marginTop: 16,
                    backgroundColor: merchant?.color,
                    height: 50,
                    borderRadius: 8,
                    alignItems: 'center',
                    justifyContent: 'center'
                }}>
                <Text style={{
                    fontSize: 15, fontFamily: 'Nunito_700Bold', fontWeight: '500'
                }}>Lọc kết quả</Text>
            </TouchableOpacity>
        </View>
    );
}

const styles = {
    itemFilter: {
        padding: 10,
        borderWidth: 1,
        alignItems: 'center',
        justifyContent: 'center',
        marginRight: 10,
        borderRadius: 6
    }
}